import api from "../../api/api";

export const gettotalusersbyusertypeThunk = async (data) =>
  await api.get(`gettotalusersbyusertype/${data.usertype}`);

export const userSwapThunk = async (data) =>
  await api.post(`transferolduserownership`, data);

export const newUserSwapThunk = async (data) =>
  await api.post(`transferuserownership`, data);

export const getAllDistricts = async () =>
  await api.get(`getdistrictsofstate/20`);

export const getAllBlocks = async (data) =>
  await api.get(`getblocksofdistricts/20/${data.districtId}`);
